import React from "react";
import { Col, Row } from "react-bootstrap";
import {
    DiJavascript1,
    DiReact,
    DiNodejs,
    DiGit,
    DiJava, DiUnitySmall,
} from "react-icons/di";
import {
    SiNextdotjs,
    SiPostgresql, SiPython, SiGooglecloud,
} from "react-icons/si";
import { VscAzure } from "react-icons/vsc";

import { TbBrandCSharp } from "react-icons/tb";
import {TbBrandTypescript} from "react-icons/tb";
import { FaMicrosoft, FaWindows } from "react-icons/fa";

function Techstack() {
  const labelStyle = { marginTop: "8px", fontSize: "1.2rem", textAlign: "center" };
  const iconStyle = { fontSize: '48px' }; 

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
        <p style={labelStyle}>JavaScript</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <TbBrandTypescript />
        <p style={labelStyle}>TypeScript</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
              <DiJava />
              <p style={labelStyle}>Java</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
        <p style={labelStyle}>Node.js</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
        <p style={labelStyle}>React</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <TbBrandCSharp />
      <p style={labelStyle}>C#</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPython />
        <p style={labelStyle}>Python</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNextdotjs />
        <p style={labelStyle}>Next.js</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
        <p style={labelStyle}>Git</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGooglecloud />
        <p style={labelStyle}>Google Cloud</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <VscAzure />
        <p style={labelStyle}>Azure</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaMicrosoft style={iconStyle} />
         <p style={labelStyle}>Intune</p>
       </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaWindows style={iconStyle} />
        <p style={labelStyle}>Active Directory</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql />
        <p style={labelStyle}>PostgreSQL</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
              <DiUnitySmall />
              <p style={labelStyle}>Unity</p>
      </Col>
    </Row>
  );
}

export default Techstack;
